import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useUpgrade = defineStore('useUpgrade', () => {

    const open = ref(false); 
    
    const isShown = computed(() => open.value);
    
    const show = () => {
        open.value = true;
    }
    
    const hide = () => {
        open.value = false;
    }
    
    return {
        open,
        isShown,
        show,
        hide
    }
})